<div role="status" class="c-section-alerts">
  <div
    *ngIf="rolledOverTo && hasEditListPermission"
    class="alert alert--flex alert-warning qa-section-alerts__rolled-over-to"
  >
    <span i18n="@@sectionAlerts-status-sectionHasNewerVersion"
      >This section has a newer version.</span
    >
    <a
      [href]="getSectionUrl(rolledOverTo.id)"
      class="btn btn-alert"
      i18n="@@sectionAlerts-link-viewNewerVersion"
      >View newer version</a
    >
  </div>

  <div
    *ngIf="list?.is_archived"
    class="alert alert-danger qa-section-alerts__archived"
  >
    <ng-container i18n="@@sectionAlerts-status-sectionArchived"
      >This section has been archived</ng-container
    >
  </div>

  <div
    *ngIf="hasTimePeriodExpired"
    class="alert alert-danger qa-section-alerts__time-period--expired"
  >
    <strong i18n="@@sectionAlerts-status-warning">Warning</strong>
    <ng-container i18n="@@sectionAlerts-status-timePeriodEnded">
      This section relates to the term
      {{ list.period.description }} which ended on
      {{ list.period.endAsDate | amLocale : locale | amDateFormat : 'L' }}
    </ng-container>
  </div>

  <div
    *ngIf="hasTimePeriodNotStarted"
    class="alert alert-warning qa-section-alerts__time-period--not-started"
  >
    <ng-container i18n="@@sectionAlerts-status-timePeriodNotStarted">
      This section relates to the term {{ list.period.description }} which does
      not start until
      {{ list.period.startAsDate | amLocale : locale | amDateFormat : 'L' }}
    </ng-container>
  </div>
</div>
